import { useState } from "react";

const useShowDialogAlert = (customToggle = null) => {
    //#region States
    const [show, setShow] = useState(false);
    //#endregion
    //#region Functions
    const defaultToggleShow = value => {
        setShow(prev => value !== null ? value : !prev);
    }
    const toggleShow = (value = null) => {
        if (customToggle) {
            customToggle(() => defaultToggleShow(value), value !== null ? value : !show);
            return;
        }
        defaultToggleShow(value);
    }
    //#endregion
    return { 
        value: show, 
        open: () => setShow(true),
        hide: () => setShow(false),
        set: setShow, 
        toggle: toggleShow
    }; 
}

export default useShowDialogAlert;